// Module
var code = "<div> <button ng-click=\"gcal.addToCalendar();\">Add to Google Calendar</button> </div>";
// Exports
module.exports = code;